import { Typography } from "@mui/material";
import clsx from "clsx";

// Helpers
import IconToShow from "./IconToShow";
import { getLocalDate } from "@/Common/helpers/Dates";
import { ILocation } from "@/Common/interfaces/location";

interface IShowMessageProps {
	error?: boolean;
	iconError?: boolean;
	message?: string;
	dateToUse?: Date | string | null;
	format?: string;
	location: ILocation;
	showIcon?: boolean;
}

const ShowMessage = (props: IShowMessageProps) => {
	const { dateToUse, format, location, showIcon, message = "", error = false, iconError = false } = props;

	return (
		<Typography
			className={clsx({
				"!font-sans !text-[14.5px]": true,
				"!text-default": !error,
				"!text-alert-color": error,
			})}
		>
			{showIcon && <IconToShow iconError={iconError} error={error} />}
			{dateToUse ? `${message} ${getLocalDate(dateToUse, format, location.timezone)}` : message || "Suggestion"}
		</Typography>
	);
};

export default ShowMessage;
